function downloadResource(lightbox) {
    const url = lightbox.getAttribute('href');
    if(lightbox.classList.contains('processed') || !url.includes("mainframe/dynamic-config")) {
        return;
    }

    lightbox.classList.add('processed');

    const filename = 'tau-media-' + lightbox.getAttribute('data-index');

    fetch(url + '?t=' + new Date().getTime(), {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache'
    })
    .then(response => response.blob())
    .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        lightbox.setAttribute('href', blobUrl);
        lightbox.setAttribute('download', filename);
    })
    .catch(e => {
        console.error(e);
        lightbox.classList.remove('processed');
    });
}

const observer = new MutationObserver((mutationsList, observerInstance) => {
    const lightboxContainer = document.querySelector(".Lightbox-container");
    if (lightboxContainer) {
        const lightboxes = lightboxContainer.querySelectorAll("a.Lightbox-slide");
        if (lightboxes.length > 0) {
            lightboxes.forEach(lightbox => {
                downloadResource(lightbox);
                observerInstance.disconnect();
            });
        }
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

const MediaGridElement = document.querySelector(".MediaGrid");
if (MediaGridElement) {
    const MediaGridMoreLink = MediaGridElement.querySelector('.MediaGrid-more');
    MediaGridMoreLink && MediaGridMoreLink.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        MediaGridElement.classList.toggle('is-collapsed');
    });

    const MediaGridWrapper = MediaGridElement.querySelector('.MediaGrid-wrapper');
    const MediaGridInner = MediaGridElement.querySelector('.MediaGrid-inner');
    const MediaGridMedia = MediaGridElement.querySelector('.MediaGrid-media');
    const MediaItem = MediaGridElement.querySelector('.MediaItem');

    let lastUpdateTimestamp = 0;
    function syncHeight() {
        requestAnimationFrame((timestamp) => {
            if (lastUpdateTimestamp < timestamp) {
                const height = MediaGridInner.offsetHeight;
                MediaGridWrapper.style.setProperty('--grid-height', height + 'px');
                lastUpdateTimestamp = timestamp;
            }
        });
    }
    function collapsedHeight() {
        requestAnimationFrame((timestamp) => {
            const itemHeight = MediaItem.offsetHeight;
            MediaGridMedia.style.setProperty('--collapsed-height', 2 * (itemHeight + 24) - 10 + 'px');
        });
    }

    const resizeObserver = new ResizeObserver((entries) => {
        requestAnimationFrame(() => {
            collapsedHeight();
            syncHeight();
        });
    });
    if (MediaGridInner) resizeObserver.observe(MediaGridInner);
    if (MediaItem) resizeObserver.observe(MediaItem);

    window.addEventListener('resize', () => {
        collapsedHeight();
        syncHeight();
    });
}


// rain effects here
const MainCanvas = document.getElementById('canvas');
MainCanvas.width = window.innerWidth;
MainCanvas.height = window.innerHeight;

const CanvasContext = MainCanvas.getContext('2d');
const BufferCanvas = document.createElement("canvas");
BufferCanvas.width = MainCanvas.width;
BufferCanvas.height = MainCanvas.height;
const BufferContext = BufferCanvas.getContext("2d");
const Drops = [
    document.getElementById('drop1'),
    document.getElementById('drop2'),
    document.getElementById('drop3'),
];
const Streaks = [
    document.getElementById('streak1'),
    document.getElementById('streak2'),
    document.getElementById('streak3'),
];

const FadeColor = 'rgba(223,223,223,0.2)';
const MatteColor = 'rgba(223,223,223,1)';

function getRandomDrop() {
    return Drops[Math.floor(Math.random() * Drops.length)];
}
function getRandomStreak() {
    return Streaks[Math.floor(Math.random() * Streaks.length)];
}

let dropletTicks = 0;
let altStreakTicks = 0;
function doUpdate() {
    // Copy buffer to live canvas
    CanvasContext.clearRect(0, 0, MainCanvas.width, MainCanvas.height);
    CanvasContext.drawImage(BufferCanvas, 0, 0);

    // Fade and blur canvas
    BufferContext.fillStyle = FadeColor;
    // BufferContext.filter = 'blur(3px)';
    BufferContext.fillRect(0, 0, BufferCanvas.width, BufferCanvas.height);
    BufferContext.filter = null;

    // Add droplet
    if (dropletTicks > 0) {
        dropletTicks --;
    } else {
        dropletTicks = Math.round(Math.random() * Math.random() * 120);
        addDroplet();
    }
    drawDroplets();

    // The new streaks that leave droplets behind
    drawAltStreaks();
    if (altStreakTicks > 0) {
        altStreakTicks --;
    } else {
        altStreakTicks = 15 + Math.round(Math.random() * 165);
        addAltStreak();
    }
}

let droplets = [];
function addDroplet(x, y, size, rotation, speed) {
    x = x ?? Math.round(Math.random() * MainCanvas.width);
    y = y ?? Math.round(Math.random() * MainCanvas.height);
    size = size ?? 20 + Math.random() * 60;
    speed = speed ?? 0.5 + Math.random() * 3;
    rotation = rotation ?? (-0.125 + Math.random() * 0.25) * Math.PI;
    droplets.push({x: x, y: y, size: size, rotation: rotation, speed: speed, tick: 1, img: getRandomDrop()});
}

function drawDroplets() {
    for(let i = droplets.length - 1; i > -1; i--) {
        let droplet = droplets[i];
        droplet.tick += Math.round(Math.random() * droplet.size / 50);
        droplet.size -= droplet.speed / 10;
        droplet.x -= droplet.speed * Math.sin(droplet.rotation);
        droplet.y += Math.abs(droplet.speed * Math.cos(droplet.rotation));
        BufferContext.save();
        BufferContext.globalAlpha = 10 / droplet.tick;
        BufferContext.translate(droplet.x, droplet.y);
        BufferContext.rotate(droplet.rotation);
        BufferContext.globalAlpha = 0.2;

        BufferContext.drawImage(
            droplet.img,
            0,
            0,
            droplet.size,
            droplet.size
        );
        BufferContext.restore();
        if (droplet.y > (MainCanvas.height + droplet.size) || droplet.size < 1 || droplet.tick > 500) {
            droplets.splice(i, 1);
        }
    }
}

let altStreaks = [];
function drawAltStreaks() {
    for (let i = altStreaks.length - 1; i > -1; i --) {
        let altStreak = altStreaks[i];
        altStreak.tick ++;
        const cycle1 = altStreak.delta1 * Math.sin(Math.PI * (altStreak.tick) / altStreak.cycle1);
        const cycle2 = altStreak.delta2 * Math.sin(Math.PI * (altStreak.tick) / altStreak.cycle2);
        altStreak.x += altStreak.drift;
        const x = Math.round(altStreak.x + cycle1 + cycle2);
        const speedFactor = Math.sin(Math.PI * (altStreak.tick) / altStreak.speedCycle);
        const yDelta = altStreak.speed * (1.5 + 0.25 * speedFactor);
        altStreak.y += Math.round(altStreak.speed * yDelta);

        const dx = altStreak.lastX - x;
        const dy = altStreak.lastY - altStreak.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const rotation = Math.asin(dx / distance);

        altStreak.lastX = x;
        altStreak.lastY = altStreak.y;

        const size = altStreak.size * (1.5 - 0.5 * speedFactor);

        BufferContext.save();
        BufferContext.translate(x, altStreak.y);
        BufferContext.rotate(rotation);

        BufferContext.globalAlpha = 0.2;

        // add a trailing droplet every once a while
        if(Math.random() < 0.15) {
            addDroplet(x + 60, altStreak.y, size * Math.random() / 2, rotation, 0.2 + Math.random() * 6);
        }

        BufferContext.drawImage(
            getRandomStreak(),
            0,
            0,
            size,
            size
        );

        BufferContext.restore();

        if (altStreak.y > (MainCanvas.height + altStreak.size)) altStreaks.splice(i, 1);
    }
}

function addAltStreak() {
    const x = Math.round(Math.random() * MainCanvas.width);
    const delta1 = 5 + Math.random() * 5;
    const delta2 = 5 + Math.random() * 5;
    const cycle1 = 20 + Math.random() * 20;
    const cycle2 = 30 + Math.random() * 50;
    const drift = -5 + Math.random() * 10;
    const speedFactor = Math.random();
    const speed = 2 + speedFactor * 2;
    const speedCycle = 60 + Math.random() * 30;
    const size = 50 + speedFactor * 60;
    const tick = Math.round(Math.random() * 30);
    altStreaks.push({
        x,
        y: -100,
        lastX: x,
        lastY: -100,
        delta1,
        delta2,
        cycle1,
        cycle2,
        drift,
        speed,
        speedCycle,
        size,
        tick,
    });
}


const frameDelay = 1000 / 60;
let nextFrame = 0;
function doFrame() {
    const now = Date.now();
    if (now >= nextFrame) {
        nextFrame = now + frameDelay;
        doUpdate();
    }
    requestAnimationFrame(doFrame);
}

function startAnimation() {
    BufferContext.fillStyle = MatteColor;
    BufferContext.fillRect(0, 0, BufferCanvas.width, BufferCanvas.height);
    requestAnimationFrame(doFrame);
}

window.addEventListener('load', startAnimation);

